export default __webpack_public_path__ + "static/media/hand-icon.2079a532.svg";